import axios from "@/axios/axios";

import * as apis from "@/apis";
import * as errors from "@/errors"
import * as successes from "@/successes"

import {getAxiosTokenConfig, getEmptyCurrentReservation, getNextTime, sendAction, timeToMoment} from "@/helpers";

import {notifyError, notifySuccess} from "@/toast-notifications";

import * as actionTypes from "../actions";
import queryClient from "@/queries/queryClient";
import { RESERVATIONS_COUNTS_KEY } from "@/queries/reservations/hooks";

const invalidateReservationMonthCount = (reservation) => {
    const start_time = timeToMoment(reservation.start_time);
    queryClient.invalidateQueries([RESERVATIONS_COUNTS_KEY, { month: start_time.month() + 1, year: start_time.year() }]);
}

// SET CURRENT RESERVATION
export const SET_CURRENT_RESERVATION = "SET_CURRENT_RESERVATION";

export const setCurrentReservation = (id, reservation = null) => {
    return (dispatch, getState) => {

        if(!reservation) {
            const reservations = getState().reservationsReducer.reservations;
            reservation = reservations.find(reservation => reservation.id === id);
        }
        
        dispatch(
            {
                type: SET_CURRENT_RESERVATION,
                reservation,
            }
        );
    };
};

// SET EMPTY CURRENT RESERVATION
export const setEmptyCurrentReservation = () => {
    return dispatch => {
        const reservation = getEmptyCurrentReservation();
        dispatch(
            {
                type: SET_CURRENT_RESERVATION,
                reservation: reservation
            }
        );
    };
};

// SET PRE FILLED CURRENT RESERVATION
export const setPreFilledCurrentReservation = (tableId, preFilledfields = {}) => {

    const { start_time } = preFilledfields;
    preFilledfields = {
        ...preFilledfields,
        start_time: start_time? getNextTime(start_time): start_time,
    };

    return dispatch => {
        const reservation = {
            ...getEmptyCurrentReservation(),
            ...preFilledfields,
            tables: tableId ? [tableId] : [],
        };

        dispatch(
            {
                type: SET_CURRENT_RESERVATION,
                reservation: reservation
            }
        );
    };
};

export const SET_STANDBY_RESERVATION = "SET_STANDBY_RESERVATION";

export const setStandbyReservation = (reservation) => {
    return dispatch => dispatch(sendAction(SET_STANDBY_RESERVATION, { data: reservation, }));
}

// NEW RESERVATION

export const newReservation = (preFilledfields = {}) => {
    return dispatch => {
        dispatch(setPreFilledCurrentReservation(null, preFilledfields));
        dispatch({ type: actionTypes.OPEN_RESERVATION_MODAL });
    };
};

// GET RESERVATIONS
export const GET_RESERVATIONS_REQUEST = "GET_RESERVATIONS_REQUEST";
export const GET_RESERVATIONS_SUCCESS = "GET_RESERVATIONS_SUCCESS";
export const GET_RESERVATIONS_ERROR = "GET_RESERVATIONS_ERROR";

export const getReservationsRequest = () => {
    return {
        type: GET_RESERVATIONS_REQUEST,
        loading: true
    };
};
export const getReservationsSuccess = (reservations) => {
    return {
        type: GET_RESERVATIONS_SUCCESS,
        loading: false,
        error: null,
        reservations,
    };
};
export const getReservationsError = (error) => {
    return {
        type: GET_RESERVATIONS_ERROR,
        loading: false,
        error
    };
};
export const getReservations = () => {
    return dispatch => {
        dispatch(getReservationsRequest());
        axios.get(apis.GET_RESERVATIONS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getReservationsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getReservationsError(errors.GET_RESERVATIONS_ERROR));
                notifyError(errors.GET_RESERVATIONS_ERROR);
            });
    };
};

// ADD RESERVATION
export const ADD_RESERVATION_REQUEST = "ADD_RESERVATION_REQUEST";
export const ADD_RESERVATION_SUCCESS = "ADD_RESERVATION_SUCCESS";
export const ADD_RESERVATION_ERROR = "ADD_RESERVATION_ERROR";

export const addReservationRequest = () => {
    return {
        type: ADD_RESERVATION_REQUEST,
        loading: true
    };
};
export const addReservationSuccess = (reservation) => {
    invalidateReservationMonthCount(reservation);
    return {
        type: ADD_RESERVATION_SUCCESS,
        loading: false,
        error: null,
        reservation
    };
};
export const addReservationError = (error) => {
    return {
        type: ADD_RESERVATION_ERROR,
        loading: false,
        error
    };
};
export const addReservation = (reservation) => {
    return dispatch => {
        dispatch(addReservationRequest());
        axios.post(apis.ADD_RESERVATION_API, reservation, getAxiosTokenConfig())
            .then(response => {
                dispatch(addReservationSuccess(response.data));
                notifySuccess(successes.ADD_RESERVATION_SUCCESS);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            })
            .catch(error => {
                dispatch(addReservationError(errors.ADD_RESERVATION_ERROR));
                notifyError(errors.ADD_RESERVATION_ERROR);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            });
    };
};

// DELETE RESERVATION
export const DELETE_RESERVATION_REQUEST = "DELETE_RESERVATION_REQUEST";
export const DELETE_RESERVATION_SUCCESS = "DELETE_RESERVATION_SUCCESS";
export const DELETE_RESERVATION_ERROR = "DELETE_RESERVATION_ERROR";

export const deleteReservationRequest = () => {
    return {
        type: DELETE_RESERVATION_REQUEST,
        loading: true
    };
};
export const deleteReservationSuccess = (reservationId) => {
    queryClient.invalidateQueries(RESERVATIONS_COUNTS_KEY);
    return {
        type: DELETE_RESERVATION_SUCCESS,
        loading: false,
        error: null,
        reservationId
    };
};
export const deleteReservationError = (error) => {
    return {
        type: DELETE_RESERVATION_ERROR,
        loading: false,
        error
    };
};
export const deleteReservation = (id) => {
    return dispatch => {
        dispatch(deleteReservationRequest());
        axios.delete(apis.DELETE_RESERVATION_API + id + "/", getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteReservationSuccess(id));
                notifySuccess(successes.DELETE_RESERVATION_SUCCESS);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            })
            .catch(error => {
                dispatch(deleteReservationError(error));
                notifyError(errors.DELETE_RESERVATION_ERROR);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            });
    };
};

// UPDATE RESERVATION
export const UPDATE_RESERVATION_REQUEST = "UPDATE_RESERVATION_REQUEST";
export const UPDATE_RESERVATION_SUCCESS = "UPDATE_RESERVATION_SUCCESS";
export const UPDATE_RESERVATION_ERROR = "UPDATE_RESERVATION_ERROR";

export const updateReservationRequest = () => {
    return {
        type: UPDATE_RESERVATION_REQUEST,
        loading: true
    };
};
export const updateReservationSuccess = (reservation) => {
    queryClient.invalidateQueries(RESERVATIONS_COUNTS_KEY);
    return {
        type: UPDATE_RESERVATION_SUCCESS,
        loading: false,
        error: null,
        reservation
    };
};
export const updateReservationError = (error) => {
    return {
        type: UPDATE_RESERVATION_ERROR,
        loading: false,
        error
    };
};
export const updateReservation = (reservation) => {
    return dispatch => {
        dispatch(updateReservationRequest());
        axios.patch(apis.UPDATE_RESERVATION_API + reservation.id + "/", reservation, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateReservationSuccess(response.data));
                notifySuccess(successes.UPDATE_RESERVATION_SUCCESS);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            })
            .catch(error => {
                dispatch(updateReservationError(error));
                notifyError(errors.UPDATE_RESERVATION_ERROR);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            });
    };
};

// not dry at all but in order to 
// not break anything this must be duplicated
// without modal closing
export const onlyUpdateReservation = (reservation) => {
    return dispatch => {
        dispatch(updateReservationRequest());
        axios.patch(apis.UPDATE_RESERVATION_API + reservation.id + "/", reservation, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateReservationSuccess(response.data));
                notifySuccess(successes.UPDATE_RESERVATION_SUCCESS);
            })
            .catch(error => {
                dispatch(updateReservationError(error));
                notifyError(errors.UPDATE_RESERVATION_ERROR);
            });
    };
};

export const UPDATE_RESERVATION_LOCALLY = "UPDATE_RESERVATION_LOCALLY";

// CONFIRM RESERVATION
export const CONFIRM_RESERVATION_REQUEST = "CONFIRM_RESERVATION_REQUEST";
export const CONFIRM_RESERVATION_SUCCESS = "CONFIRM_RESERVATION_SUCCESS";
export const CONFIRM_RESERVATION_ERROR = "CONFIRM_RESERVATION_ERROR";

export const confirmReservationRequest = () => {
    return {
        type: CONFIRM_RESERVATION_REQUEST,
        loading: true
    };
};
export const confirmReservationSuccess = (reservation) => {
    invalidateReservationMonthCount(reservation);
    return {
        type: CONFIRM_RESERVATION_SUCCESS,
        loading: false,
        error: null,
        reservation
    };
};
export const confirmReservationError = (error) => {
    return {
        type: CONFIRM_RESERVATION_ERROR,
        loading: false,
        error
    };
};
export const confirmReservation = (reservation) => {
    return dispatch => {
        dispatch(confirmReservationRequest());
        axios.patch(apis.CONFIRM_RESERVATION_API + reservation.id + "/", reservation, getAxiosTokenConfig())
            .then(response => {
                dispatch(confirmReservationSuccess(response.data));
                notifySuccess(successes.CONFIRM_RESERVATION_SUCCESS);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            })
            .catch(error => {
                dispatch(confirmReservationError(error));
                notifyError(errors.CONFIRM_RESERVATION_ERROR);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            });
    };
};

// CANCEL RESERVATION
export const CANCEL_RESERVATION_REQUEST = "CANCEL_RESERVATION_REQUEST";
export const CANCEL_RESERVATION_SUCCESS = "CANCEL_RESERVATION_SUCCESS";
export const CANCEL_RESERVATION_ERROR = "CANCEL_RESERVATION_ERROR";

export const cancelReservationRequest = () => {
    return {
        type: CANCEL_RESERVATION_REQUEST,
        loading: true
    };
};
export const cancelReservationSuccess = (reservation) => {
    invalidateReservationMonthCount(reservation);
    return {
        type: CANCEL_RESERVATION_SUCCESS,
        loading: false,
        error: null,
        reservation
    };
};
export const cancelReservationError = (error) => {
    return {
        type: CANCEL_RESERVATION_ERROR,
        loading: false,
        error
    };
};
export const cancelReservation = (reservation) => {
    return (dispatch, getState) => {
        const data = {
            cancelled : true,
            restaurant_cancel_message: reservation.restaurant_cancel_message
        };
        dispatch(cancelReservationRequest());
        axios.patch(apis.CANCEL_RESERVATION_API + reservation.id + "/", data, getAxiosTokenConfig())
            .then(response => {
                dispatch(cancelReservationSuccess(response.data));
                notifySuccess(successes.CANCEL_RESERVATION_SUCCESS);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            })
            .catch(error => {
                dispatch(cancelReservationError(error));
                notifyError(errors.CANCEL_RESERVATION_ERROR);
                dispatch({type: actionTypes.CLOSE_RESERVATION_MODAL})
            });
    };
};

// MARK AS READ RESERVATION
export const MARK_AS_READ_RESERVATION_REQUEST = "MARK_AS_READ_RESERVATION_REQUEST";
export const MARK_AS_READ_RESERVATION_SUCCESS = "MARK_AS_READ_RESERVATION_SUCCESS";
export const MARK_AS_READ_RESERVATION_ERROR = "MARK_AS_READ_RESERVATION_ERROR";

export const markAsReadReservationRequest = () => {
    return {
        type: MARK_AS_READ_RESERVATION_REQUEST,
        loading: true
    };
};
export const markAsReadReservationSuccess = (reservation) => {
    return {
        type: MARK_AS_READ_RESERVATION_SUCCESS,
        loading: false,
        error: null,
        reservation
    };
};
export const markAsReadReservationError = (error) => {
    return {
        type: MARK_AS_READ_RESERVATION_ERROR,
        loading: false,
        error
    };
};
export const markAsReadReservation = (id) => {
    return dispatch => {
        const data = {
            read: true,
            modified: false, // This should not exist
        }
        dispatch(markAsReadReservationRequest());
        axios.patch(apis.MARK_AS_READ_RESERVATION_API + id + "/", data, getAxiosTokenConfig())
            .then(response => {
                dispatch(markAsReadReservationSuccess(response.data));
            })
            .catch(error => {
                dispatch(markAsReadReservationError(error));
            });
    };
};

export const SET_RESERVATIONS_LIST_LOADING = "SET_RESERVATIONS_LIST_LOADING";

export const UPDATE_RESERVATION_COUNT = "UPDATE_RESERVATION_COUNT";
export const updateReservationsCount = (month, year, reservationsCounts) => {
    return dispatch => {
        dispatch(sendAction(UPDATE_RESERVATION_COUNT, { month, year, reservationsCounts }));
    }
}

export const GET_RESERVATION_PAYMENT_REQUEST = "GET_RESERVATION_PAYMENT_REQUEST";
export const GET_RESERVATION_PAYMENT_SUCCESS = "GET_RESERVATION_PAYMENT_SUCCESS";
export const GET_RESERVATION_PAYMENT_ERROR = "GET_RESERVATION_PAYMENT_ERROR";
export const getReservationPayment = paymentId => {
    return dispatch => {
        dispatch(sendAction(GET_RESERVATION_PAYMENT_REQUEST, { paymentId }));
        axios.get(`payments/reservations/${paymentId}/`, getAxiosTokenConfig())
            .then(({ data }) => dispatch(sendAction(GET_RESERVATION_PAYMENT_SUCCESS, { payment: data, })))
            .catch(error => {
                dispatch(sendAction(GET_RESERVATION_PAYMENT_ERROR, { error, }));
                notifyError(errors.GET_RESERVATION_PAYMENT_ERROR);
            });
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/reservations.js